/**
* Click To Play JS
* -----------------------------------------------------------------------------
*
* All the JS for the Click To Play component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'click-to-play',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.click-to-play' ).each( function( key, component ) {
        const navHeight = $( '.navbar' ).height();
        const adminbarHeight = $( '#wpadminbar' ).length > 0 ? $( '#wpadminbar' ).height() : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );


        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            pin: $( '.click-to-play' ).find( '.click-to-play__inner' ),
            start: 'top ' + topOffset,
            scrub: 1,
          },
        } );

        tl.to( $( '.click-to-play__btn' ), {zIndex: 1}, 0 );
        tl.fromTo( $( '.click-to-play__loop-video-btn' ), {color: '#017BB5'}, {color: '#fff', ease: 'linear', duration: '2.5'}, 0 );
        tl.to( $( '.click-to-play__panel' ), {clipPath: 'circle(100%)', ease: 'linear', duration: '4'}, 0 );
        tl.fromTo( $( '.click-to-play__btn' ), {opacity: 0}, {opacity: 1, duration: '0.15'}, '-=1.5' );
        tl.fromTo( $( '.click-to-play__btn' ), {y: '100%'}, {y: '0%', duration: '0.35'}, '-=1.5' );
        tl.fromTo( $( '.click-to-play__arrow' ), {opacity: 0}, {opacity: 1, duration: '0.25'}, '-=1.25' );
        tl.fromTo( $( '.click-to-play__arrow' ), {rotate: '-50', x: '-100%'}, {rotation: 0, x: '0%', duration: '0.35'}, '-=1.25' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
